/******************************************************************************
 *** BgtOvrlEmpGrnamtViewDialog ** 총괄조합비 * 지출결의서 상세정보 * 우성실무원 교부금 상세내역 조회 모달
*******************************************************************************/
import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import Button from "@/js/common/ui/Button";

interface Props {
    ovrlMbsdsExpndDocId: string; // 지출결의서 문서 ID
    setModalOpen: Function;
    setCallTime?: Function;
}

const BgtOvrlEmpGrnamtViewDialog = ({ ovrlMbsdsExpndDocId, setModalOpen, setCallTime }: Props) => {
  const [dataArr, setDataArr] = React.useState<any[]>([]);

  // 합계(서버가 내려주는 값 그대로 표시)
  const [sumMbsdsSumAmt  , setSumMbsdsSumAmt  ] = React.useState<string>("0"); // 조합비 합계
  const [sumOperAmt      , setSumOperAmt      ] = React.useState<string>("0"); // 운영금 합계
  const [sumDtbnAmt      , setSumDtbnAmt      ] = React.useState<string>("0"); // 교부금 합계
  const [sumDtbnNopeCnt  , setSumDtbnNopeCnt  ] = React.useState<string>("0"); // 집중국 인원 합계
  const [sumDtbnPstofcAmt, setSumDtbnPstofcAmt] = React.useState<string>("0"); // 집중국 금액 합계
  const [sumDtbnSumAmt   , setSumDtbnSumAmt   ] = React.useState<string>("0"); // 총배정액 합계

    // 조회
    React.useEffect(() => {
        if (Util.isEmpty(ovrlMbsdsExpndDocId)) return;

        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/ovrl/expnd/select-ovrl-emp-grnamt-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                ovrlMbsdsExpndDocId: ovrlMbsdsExpndDocId
            },
            onSuccessFn: (res: any) => {
                const list = res.result.list;
                setDataArr(list);

                const sum = res.result.listSum;
                setSumMbsdsSumAmt  (sum.mbsdsSumAmt  ); // 조합비 합계
                setSumOperAmt      (sum.operAmt      ); // 운영금 합계
                setSumDtbnAmt      (sum.dtbnAmt      ); // 교부금 합계
                setSumDtbnNopeCnt  (sum.dtbnNopeCnt  ); // 집중국 인원 합계
                setSumDtbnPstofcAmt(sum.dtbnPstofcAmt); // 집중국 금액 합계
                setSumDtbnSumAmt   (sum.dtbnSumAmt   ); // 총배정액 합계

                AppContext.hideSpinner();
            },
        });
    }, [ovrlMbsdsExpndDocId]);

  // =========================
  // 닫기
  // =========================
  const closeModal = () => {
    setModalOpen(false);
    if (setCallTime) setCallTime(new Date());
  };

    return (
        <div className="w100p dpFlx jcC">
            <div style={{width: "920px"}} className="p10">
                <div className="mb10 dpFlx jcSb">
                    <div>
                        <span className="fm-b fs16 fc007bff ls1 fw700">우정실무원 교부금 배정 상세내용</span>
                    </div>
                </div>
                <div className="bd1 bdcEDEDED bdrd2 ofH">
                    <table className="w100p tbl-collapse tlF">
                        <colgroup>
                            <col className="w140" /> {/* 지방본부별 */}
                            <col className="w120" /> {/* 조합비총액(금액) */}
                            <col className="w40" /> {/* 운영% */}
                            <col className="w120" /> {/* 운영금액 */}
                            <col className="w40" /> {/* 교부% */}
                            <col className="w120" /> {/* 교부금액 */}
                            <col className="w80" /> {/* 집중국 인원 */}
                            <col className="w120" /> {/* 집중국 금액 */}
                            <col className="w120" /> {/* 총배정액(읽기) */}
                        </colgroup>
                        <thead>
                        <tr className="h25">
                            <th rowSpan={2} className="bd1 bdcDFDFDF bgcF1F8FF taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">지방본부별</span>
                            </th>
                            <th rowSpan={2} className="bd1 bdcDFDFDF bgcF1F8FF taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">조합비총액</span>
                            </th>
                            <th colSpan={2} className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">운영금(본부비)</span>
                            </th>
                            <th colSpan={5} className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">교부금(지방본부비)</span>
                            </th>
                        </tr>
                        <tr className="h25">
                            <th className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">%</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">금액</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">%</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">금액</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">집중국 인원</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">집중국 금액</span>
                            </th>
                            <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                <span className="dpFlx aiC jcC fs13 fc777777 wsNw">총배정액</span>
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {dataArr.length === 0 ? (
                            <tr>
                                <td colSpan={9} className="bd1 bdcEDEDED">
                                    <div className="h44 dpFlx aiC jcC fc999999 fm-c fs13">조회된 데이터가 없습니다.</div>
                                </td>
                            </tr>
                        ) : (
                            dataArr.map((row: any, index: number) => {
                            const key = String(row.grnamtOrgCd || index);
                            const zebraBg = index % 2 === 0 ? "bgcWhite" : "bgcF9F9F9";

                            return (
                                <tr key={key} className={zebraBg} style={{height: "30px"}}>
                                    {/* 지방본부 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcC pw12 fm-c fs13 fc333333 wsNw ofH toE">{row.grnamtOrgNm}</span>
                                    </td>
                                    {/* 조합비총액 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                            {Util.comma(row.mbsdsSumAmt ?? "0")}
                                        </span>
                                    </td>
                                    {/* 운영% */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcC pw6 fm-b fs13 fc333333">{row.operRt ?? "0"}</span>
                                    </td>
                                    {/* 운영금액 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                            {Util.comma(row.operAmt ?? "0")}
                                        </span>
                                    </td>
                                    {/* 교부% */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcC pw6 fm-b fs13 fc333333">{row.dtbnRt ?? "0"}</span>
                                    </td>
                                    {/* 교부금액 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                            {Util.comma(row.dtbnAmt ?? "0")}
                                        </span>
                                    </td>
                                    {/* 집중국 인원 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcC pw12 fm-b fs13 fc333333">
                                            {Util.comma(row.dtbnNopeCnt ?? "0")}
                                        </span>
                                    </td>

                                    {/* 집중국 금액 */}
                                    <td className="bd1 bdcEDEDED">
                                        <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                            {Util.comma(row.dtbnPstofcAmt ?? "0")}
                                        </span>
                                    </td>

                                    {/* 총배정액 */}
                                    <td className="bd1 bdcEDEDED">
                                        <div className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                        {Util.comma(row.dtbnSumAmt ?? "0")}
                                        </div>
                                    </td>
                                </tr>
                            );
                            })
                        )}

                        {/* 합계 row */}
                        <tr className="bgcF1F8FF h35">
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcC pw12 fm-c fs13 fc111111">합계</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcE pw12 fm-c fs13 fc007bff">{Util.comma(sumMbsdsSumAmt)}</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcC pw12 fm-c fs12 fc666666"></div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumOperAmt)}</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcC pw12 fm-c fs12 fc666666"></div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumDtbnAmt)}</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcC pw12 fm-c fs13 fc111111">{Util.comma(sumDtbnNopeCnt)}명</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumDtbnPstofcAmt)}</div>
                            </td>
                            <td className="bd1 bdcEDEDED">
                                <div className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumDtbnSumAmt)}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* 버튼(닫기만) */}
                <div className="dpFlx aiC jcC gap10 mt20">
                    <Button buttonName="닫기"
                        width={120} height={40}
                        fontFamily="fm-b" fontSize={15} letterSpacing={-0.8} 
                        variant="styCloseBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={closeModal}
                />
                </div>
            </div>
        </div>
    );
};

export default BgtOvrlEmpGrnamtViewDialog;
